const listTableColumnValue = ($timeout) => {
  const valueRegExp = /^\(?[0-9.,]+\)?$/;
  return {
    restrict: 'C',
    link (scope, elem, attrs) {
      $timeout(() => {
        let texto = $(elem).text();
        texto = angular.isFunction(texto.toString) ? texto.toString().trim() : texto;    
        if (angular.isString(texto) && texto.length > 8 && valueRegExp.test(texto)) {
          elem.css({ fontSize: '0.9em' });
        }
      }, 100);
    }
  };
};

export default angular.module('contartemx.directivas', [])
  .directive('nombreArchivo', ['$http', '$timeout', function ($http, $timeout) {

    const EXTENSIONS = {
      'application/xml': 'xml',
      'application/pdf': 'pdf'
    };

    return {
      restrict: 'A',
      scope: {
        nombreArchivo: '@nombreArchivo',
        linkDescarga: '@href',
        setLoader: '&'
      },
      link: function (scope, elem, attrs) {

        elem.click(event => {

          let linkDescarga = scope.linkDescarga || attrs['urlArchivo'],
            nombreArchivo = scope.nombreArchivo;

          if (angular.isString(linkDescarga) && linkDescarga.length > 0 && linkDescarga !== 'undefined' &&
            angular.isString(nombreArchivo) && nombreArchivo.length > 0 && nombreArchivo !== 'undefined') {

            event.preventDefault();

            let a = angular.element('<a></a>'),
              triggerClick = () => {
                a[0].click();
                a.remove();
              },
              errorHandler = () => {
                a.attr({
                  href: linkDescarga,
                  download: ''
                });
                angular.element(document.body).append(a);
                triggerClick();
              };

            a.attr('target', '_parent');

            if (typeof URL !== 'undefined' && angular.isFunction(URL.createObjectURL)) {

              try {
                scope.setLoader({ isLoading: true });
                // Save with custom name
                $http({
                  method: 'GET',
                  url: linkDescarga,
                  responseType: 'arraybuffer'
                }).then(({ data, status, headers }) => {

                  let fileType = headers('Content-Type'),
                    file = new Blob([data], { type: fileType });

                  nombreArchivo = `${nombreArchivo}.${EXTENSIONS[fileType]}`;

                  if (window.navigator && angular.isFunction(window.navigator.msSaveBlob)) {
                    window.navigator.msSaveBlob(file, nombreArchivo);
                  } else /*if (URL && angular.isFunction(URL.createObjectURL)) {
                                    //trick to download store a file having its URL
                                    let fileURL = URL.createObjectURL(file);

                                    a.attr({
                                      href: fileURL,
                                      download: nombreArchivo
                                    });

                                    angular.element(document.body).append(a);
                                    $timeout(triggerClick, 100);
                                  } else */ {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                      //window.location.href = reader.result;
                      a.attr({
                        href: reader.result,
                        download: nombreArchivo
                      });

                      angular.element(document.body).append(a);
                      $timeout(triggerClick, 100);

                    };
                    reader.readAsDataURL(file);
                  }

                }).finally(() => scope.setLoader({ isLoading: false }));

              } catch (e) {
                errorHandler();
              }
            } else {
              errorHandler();
            }

          }

        });
      }
    }

  }])
  .directive('elemReady', ($parse) => {
    return {
      restrict: 'A',
      link($scope, elem, attrs) {
        elem.ready(() => {
          /*$scope.$apply(function () {
              var func = $parse(attrs.elemReady);
              func($scope);
          });*/
          $scope.$emit("elemReady");
        });
      }
    }
  })
  .directive('longitudMaxima', () => {
    return {
      restrict: "A",
      require: 'ngModel',
      link(scope, element, attrs, ngModel) {
        attrs.$set("ngTrim", "false");

        let limitLength = parseInt(attrs.longitudMaxima);

        const validacionRfc = (ngModelValue) => {

          if (ngModel.$viewValue.length > limitLength) {
            ngModel.$setValidity('longitudMaxima', false);
            ngModel.$setViewValue(ngModel.$viewValue.substring(0, limitLength));
            ngModel.$render();
          } else {
            ngModel.$setValidity('longitudMaxima', true);
          }

          return ngModelValue;
        };
        ngModel.$parsers.push(validacionRfc);
      }
    };
  })
  .directive('validaRfc', (ServicioValidacion) => {
    return {
      restrict: 'A',
      scope: true,
      replace: true,
      require: 'ngModel',
      link(scope, elem, attrs, ngModel) {
        const validacionRfc = (ngModelValue) => {
          if (ServicioValidacion.EsRfcValido(ngModelValue)) {
            ngModel.$setValidity('validacionRfc', true);
          } else {
            ngModel.$setValidity('validacionRfc', false);
          }
          var mayusculas = ngModelValue.toUpperCase();
          if (mayusculas !== ngModelValue) {
            // see where the cursor is before the update so that we can set it back
            var selection = elem[0].selectionStart;
            ngModel.$setViewValue(mayusculas);
            ngModel.$render();
            // set back the cursor after rendering
            elem[0].selectionStart = selection;
            elem[0].selectionEnd = selection;
          }
          return mayusculas;
        };
        ngModel.$parsers.push(validacionRfc);
      }
    };
  })
  .directive('lowercase', () => {
    return {
      restrict: 'A',
      require: 'ngModel',
      link(scope, elem, attrs, ngModel) {
        const minusculas = (ngModelValue) => {
          let minusculas = ngModelValue.toLowerCase().trim();
          if (minusculas !== ngModelValue) {
            // see where the cursor is before the update so that we can set it back
            var selection = elem[0].selectionStart;
            ngModel.$setViewValue(minusculas);
            ngModel.$render();
            // set back the cursor after rendering
            elem[0].selectionStart = selection;
            elem[0].selectionEnd = selection;
          }
          return minusculas;
        };
        ngModel.$parsers.push(minusculas);
      }
    };
  })
  .directive('uppercase', () => {
    return {
      restrict: 'A',
      require: 'ngModel',
      link(scope, elem, attrs, ngModel) {
        const mayusculas = (ngModelValue) => {
          let mayusculas = ngModelValue.toUpperCase().trim();
          if (mayusculas !== ngModelValue) {
            // see where the cursor is before the update so that we can set it back
            var selection = elem[0].selectionStart;
            ngModel.$setViewValue(mayusculas);
            ngModel.$render();
            // set back the cursor after rendering
            elem[0].selectionStart = selection;
            elem[0].selectionEnd = selection;
          }
          return mayusculas;
        };
        ngModel.$parsers.push(mayusculas);
      }
    };
  })
  .directive('escKey', () => {
    return (scope, element, attrs) => {
      element.bind('keydown keypress', (evt) => {
        if (evt.which === 27) { // 27 = esc key
          scope.$apply(() => {
            scope.$eval(attrs.escKey);
          });

          evt.preventDefault();
        }
      });
      scope.$on('$destroy', () => {
        element.unbind('keydown keypress')
      })
    };
  })
  .directive("typeaheadPopup", () => {
    return {
      restrict: "E",
      replace: true,
      link: function (scope, element, attrs) {
        scope.templateUrl = attrs.templateUrl;
        scope.isOpen = function () {
          return scope.matches.length > 0;
        };
        scope.isActive = function (matchIdx) {
          return scope.active == matchIdx;
        };
        scope.selectActive = function (matchIdx) {
          scope.active = matchIdx;
        };

        scope.selectMatch = function (activeIdx) {

          scope.select({
            activeIdx: activeIdx
          });
        };
      }
    };
  })
  .directive('myMaxlength', ($compile, $log) => {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, elem, attrs, ctrl) {
        attrs.$set("ngTrim", "false");
        var maxlength = parseInt(attrs.myMaxlength, 10);
        ctrl.$parsers.push(function (value) {

          if (value.length > maxlength) {
            value = value.substr(0, maxlength);
            ctrl.$setViewValue(value);
            ctrl.$render();
          }
          return value;
        });
      }
    };
  })
  .directive('tooltip', ($timeout) => {
    return {
      restrict: 'A',
      scope: {
        title: "@tooltip"
      },
      link (scope, elem, attrs) {
        elem.attr("title", scope.title);
      }
    };
  })
  .directive('positiveIntOnly', function () {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, modelCtrl) {
        console.log(arguments)
        modelCtrl.$parsers.push(function (inputValue) {
          console.log(arguments)
          var transformedInput = inputValue ? inputValue.toString().replace(/[^0-9]/g, '') : null;

          if (transformedInput != inputValue) {
            modelCtrl.$setViewValue(transformedInput);
            modelCtrl.$render();
          }

          return transformedInput;
        });
      }
    };
  })
  .directive('listTableColumnValue', listTableColumnValue)
  .directive('listTableColumnCurrency', listTableColumnValue)
  .directive('listRowColumnCurrency', listTableColumnValue);
